<template>
    <div class="al-content" v-show="Ticket.Id">
        <div class="content-top">
            <div class="d-flex flex-row bd-highlight mb-3">
                <div class="p-2 bd-highlight" style="padding-left:0px!important">
                    <button type="button" class="btn btn-default btn-with-icon"
                            @click="showIndex">
                        <i class="ion-chevron-left"></i>Back
                    </button>
                </div>
                <div class="p-2 bd-highlight">
                    <h1 class="al-title pt-2">Ticket #{{Ticket.Id}}</h1>
                </div>
                <div class="p-2 bd-highlight">
                    <button id="btnStatus" type="button" class="btn btn-xs dropdown-toggle"
                            :class="{'btn-primary':Ticket.Status=='Working'||Ticket.Status=='Open'|| Ticket.Status == 'AutoClose','btn-warning':Ticket.Status=='Pending','btn-danger':Ticket.Status=='Closed'}"
                            data-bs-toggle="dropdown">
                        {{Ticket.Status == "Open" ? "Working" : Ticket.Status == "AutoClose" ? "Pending" : Ticket.Status }} <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="btnStatus">
                        <li>
                            <a class="dropdown-item" href="javascript:void(0);" @click="changeTicketStatus('Open')">Open</a>
                        </li>
                        <li>
                            <a class="dropdown-item" href="javascript:void(0);" @click="changeTicketStatus('Working')">Working</a>
                        </li>
                        <li>
                            <a class="dropdown-item" href="javascript:void(0);" @click="changeTicketStatus('Pending')">Pending</a>
                        </li>
                        <li>
                            <a class="dropdown-item" href="javascript:void(0);" @click="changeTicketStatus('Closed')">Closed</a>
                        </li>

                    </ul>
                </div>
                <div class="p-2 bd-highlight" v-if="checkAcl('Edit') && Ticket.Status != 'Closed'" >
                        <button id="btnAutoClose" type="button" class="btn btn-warning" v-if="!autoClose" @click="changeTicketStatus('AutoClose')">
                            Auto Close <span class="caret"></span>
                        </button>
                        <button id="btnAutoCloseCancel" type="button" class="btn btn-danger" v-if="autoClose" @click="changeTicketStatus('Working')">
                            Cancel Auto Close <span class="caret"></span>
                        </button>
                    </div>                   
                </div>      




        </div>
        <div class="row mail-client-container transparent ">
            <div class="col-md-12">
                <div>
                    <div class="panel" >
                        <div class="panel-body" >
                            <div class="message">

                                <div class="person-info row p-0">
                                    <div class="col-lg-4 col-md-12 lists-widget">
                                        <div class="pl-3" style="border-left: 4px solid #e5c649;">
                                            <div class="ms-3">
                                                <span class="">Location: </span>
                                                <span class="ml-2 fw-bold">{{Ticket.CafeName}}</span>
                                                <span class="fw-bold" style="color:pink">{{Ticket.IsMystic?' (Mystic) ':''}}</span>
                                            </div>
                                            <div class="ms-3">
                                                <span class="">Sender: </span>
                                                <span class="ml-2 fw-bold">{{Ticket.Sender}}</span>
                                            </div>
                                            <div class="ms-3">
                                                <span class="">Phone: </span>
                                                <span class="ml-2 fw-bold">{{Ticket.ContactPhone}}</span>
                                            </div>
                                            <div class="ms-3">
                                                <span class="">From: </span>
                                                <span class="ml-2">
                                                    <img style="width:20px;height:auto" class="little-human-picture" :src="require('@/assets/img/appicon/'+(Ticket.IsFromUser?'userrequest':'locationrequest')+'.png')">
                                                </span>
                                                <span class="ml-2 fw-bold">{{Ticket.IsFromUser?'User':'Location'}}</span>
                                            </div>
                                            <div class="ms-3" v-show="Ticket.PlayerCardNo!=''&&Ticket.PlayerCardNo!=null">
                                                <span class="">Player Card No: </span>
                                                <span class="ml-2 fw-bold">{{Ticket.PlayerCardNo}}</span>
                                            </div>
                                            <div class="ms-3" v-show="Ticket.DeviceUsed!=''&&Ticket.DeviceUsed!=null">
                                                <span class="">Devices Used: </span>
                                                <span class="ml-2 fw-bold">{{Ticket.DeviceUsed}}</span>
                                            </div>
                                            <div class="ms-3" v-show="Ticket.BrowserUsed!=''&&Ticket.BrowserUsed!=null">
                                                <span class="">Browser Used: </span>
                                                <span class="ml-2 fw-bold">{{Ticket.BrowserUsed}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-12 lists-widget">
                                        <div class="pl-3" style="border-left: 4px solid #e5c649;">
                                            <div class="ms-3">
                                                <span class="">Type: </span>
                                                <span class="ml-2 fw-bold">{{Ticket.Type}} issue</span>
                                            </div>
                                            <div class="ms-3">
                                                <span class="">AppType: </span>
                                                <span class="ml-2 fw-bold">{{Ticket.AppType}}</span>
                                            </div>
                                            <div class="ms-3">
                                                <span class="" v-show="Ticket.AppType!='WebGame'&&Ticket.AppType!='WebPOS'">Machine: </span>
                                                <span class="" v-show="Ticket.AppType=='WebGame'||Ticket.AppType=='WebPOS'">WebName: </span>
                                                <span class="ml-2 fw-bold">{{Ticket.MachineName}}</span>
                                            </div>
                                            <div class="ms-3">
                                                <span class="">Issue Time &nbsp;: </span>
                                                <span class="ml-2 fw-bold">{{setTime(Ticket.IssueTime)}} (Local)</span>
                                            </div>
                                            <div class="ms-3">
                                                <span class="">Report Time: </span>
                                                <span class="ml-2 fw-bold">{{setTime(Ticket.Created)}} (EST)</span>
                                            </div>
                                            <div class="ms-3" v-show="Ticket.Status=='Closed'">
                                                <span class="">Closed Time: </span>
                                                <span class="ml-2 fw-bold">{{setTime(Ticket.Updated)}} (EST)</span>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="col-lg-4 col-md-6 col-xs-12 no-padding" v-show="Ticket.Type=='player'">
                                        <div class="pl-3" style="border-left: 4px solid #e5c649;">

                                            <div class="ms-3">
                                                <span class="">Balance Before: </span>
                                                <span class="ml-2 fw-bold">${{formatMoney(Ticket.BalanceBefore)}}</span>
                                            </div>
                                            <div class="ms-3">
                                                <span class="">Balance After: </span>
                                                <span class="ml-2 fw-bold">${{formatMoney(Ticket.BalanceAfter)}}</span>
                                            </div>
                                            <div class="ms-3" v-show="Ticket.AppType=='NassPOS'||Ticket.AppType=='WebPOS'">
                                                <span class="">Drawer Balance: </span>
                                                <span class="ml-2 fw-bold">${{formatMoney(Ticket.DrawerBalance)}}</span>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <h4 class="with-line">{{Ticket.Title}}</h4>
                                <!--=================== Ticket content ======================-->

                                <div class="line"></div>
                                <div class="message-body " v-html="replaceLine(Ticket.Description)">

                                </div>
                                <div class="attachment cursor-pointer" v-show="Ticket.AppType=='NassPOS'||Ticket.AppType=='NassWinGame'||Ticket.AppType=='NassKiosk'">
                                    <div @click="openFile(`${Ticket.TicketPath}/log.log`)">
                                        <i class="file-icon ion-document"></i>
                                        <span class="file-name ng-binding">Log file</span>
                                    </div>
                                </div>
                                <!--=================== SCREENSHOT ======================-->
                                <h4 class="with-line">Screenshots</h4>
                                <div v-show="Ticket.Files.length==0">
                                    <h5>Nothing to show</h5>
                                </div>
                                <div class="row">
                                    <div v-for="(image, imageIndex) in parseScreenShot(Ticket.Files)"
                                         :key="imageIndex"
                                         class="col-sm-6 col-md-4 mt-4">
                                        <div class="screenshot" @click="openLightbox(imageIndex)">
                                            <div class="screenshot-wrapper ">
                                                <img :src="`${Ticket.TicketPath}/${image}`" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--=================== Message ======================-->
                                <h4 class="with-line">Messages</h4>
                                <div v-for="(msg, i) in Messages" :key="i" style="margin-top:25px">
                                    <h5 :style="{textAlign:msg.IsAdminReply?'left':'right'}">{{msg.Sender}}</h5>
                                    <div class="cd-timeline-content bounce-in "
                                         :class="{'message-right danger':!msg.IsAdminReply,'message-left primary':msg.IsAdminReply}">
                                        <p v-html="msg.Message!=undefined&&msg.Message.replace(/\n/gi,'<br />')"></p>
                                        <span class="small" style="opacity:.5">at {{msg.Created}}</span>
                                    </div>
                                    <div v-show="msg.IsAdminReply && checkAcl('Edit')">
                                        <span class="editable-buttons">
                                            <button type="button" class="btn btn-danger btn-with-icon btn-sm mt-3" @click="deleteMessage(msg.Id)"><i class="ion-ios-trash-outline p-1"></i></button>
                                        </span>
                                    </div>
                                    <div class="fc-clear"></div>
                                </div>

                                <div class="control" style="margin-top:25px" v-show="Ticket.Status!='Closed'">
                                    <textarea class="form-control w-100" id="message" rows="3" placeholder="Enter a message ..."></textarea>
                                </div>
                                <button type="button" class="btn btn-primary" @click="sendMessage" v-show="Ticket.Status!='Closed'">Send</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <vue-easy-lightbox escDisabled
                           moveDisabled
                           :visible="lightboxVisible"
                           :imgs="lightboxImgs"
                           :index="lightboxIndex"
                           :swipeTolerance="lightboxT"
                           @hide="lightboxHandleHide"></vue-easy-lightbox>
    </div>
</template>

<script>
   
    
    import VueEasyLightbox from 'vue-easy-lightbox'
    import { mapState, mapActions } from 'vuex'
    import c from '@/mylib/common'
    import $ from 'jquery'    
    export default {
        name: `Support`,
        components: { VueEasyLightbox},
        data: function () {
            return {                
                showStatus: false,
                myInterval: null,                
                Messages: [],
                autoClose: false,
                //lightbox
                lightboxVisible: false,
                lightboxImgs: [],
                lightboxIndex: 0,
                lightboxT: 50,       
            }
        },
        computed: mapState({
            isCheckedLogin: state => state.view.isCheckedLogin,
            Ticket: state => state.support.OpenedTicket,
            RefreshMessageTime: state => state.support.RefreshMessageTime,
        }),
        methods: {
            ...mapActions({
                'loading': 'view/setLoading',
                'showModal': 'view/showModal',
                'setGroups': 'user/setGroups',
                'call': 'api/call',                
            }),
            checkAcl(action) {
                return this.$store.state.session.acl.includes(this.$options.name + "/" + action);
            },
            checkFullAcl(router) {
                this.$store.state.session.acl.includes(router);
            },
            parseScreenShot(str) {
                try {
                    let data = JSON.parse(str);
                    return data;
                } catch {
                    return [];
                }
            },
            replaceLine(str) {
                str = str || "";
                return str.replace(/\n/gi, '<br />');
            },
            formatMoney(money,symbol) {
                return c.formatMoney(money, symbol);
            },
            setTime(strTime) {                
                /*return c.formatDate(new Date(Date.parse(strTime) + this.$store.state.session.timeOffset * 60 * 1000));*/
                return c.formatDate(new Date(Date.parse(strTime)));
            },           

            refreshMessage() {                
                this.getTicketMessages(this.$route.params.id);
                 
            },
            async start() {
                //run once
                if (!this.Ticket.Id) {
                    //get ticket data
                    this.getTicketDetail(this.$route.params.id);                    
                }               

                //this.Ticket.IssueTime = this.convertEstTime(this.Ticket.IssueTime);
                this.Ticket.Created = this.convertEstTime(this.Ticket.Created);
                this.Ticket.Updated = this.convertEstTime(this.Ticket.Updated);
                if (this.Ticket.Status == 'AutoClose')
                    this.autoClose = true;

                this.refreshMessage();
                this.myInterval = setInterval(this.refreshMessage, this.RefreshMessageTime);
            },
           
            async setRead(ticketId) {
                await this.call({ Action: 'Support/SetRead', Object: { TicketId: ticketId } })
            },
            async getTicketDetail(ticketid) {
                this.loading(true);
                const rs = await this.call({ Action: 'Support/GetTicketDetail', Object: { TicketId: ticketid } })
                this.loading(false);
                
                if (rs.Error != "") {
                    //show modal with callback name = loginView to check it whenever modal confirm triggerConfirm
                    this.showModal({ isShow: true, title: 'Error', content: rs.Error, type: 'error' });
                    //no permission                    
                    if (rs.Data == "nopermission") {
                        window.history.back();
                    }
                } else {
                    if (rs.Data == null) {
                        this.showModal({ isShow: true, title: 'Error', content: 'Ticket not found', type: 'error', callback: () => { this.$router.push("/support") } });
                    }
                    else
                    {             
                        //rs.Data.IssueTime = this.convertEstTime(rs.Data.IssueTime);
                        rs.Data.Created = this.convertEstTime(rs.Data.Created);
                        rs.Data.Updated = this.convertEstTime(rs.Data.Updated);

                        this.$store.dispatch('support/setOpenedTicket', rs.Data);
                        if (this.Ticket.Status == "AutoClose")
                            this.autoClose = true;

                    }                        
                }
            },
            async getTicketMessages(ticketid) {
                if (this.$store.state.view.loading) return;
                const rs = await this.call({ Action: 'Support/GetTicketMessages', Object: { TicketId: ticketid} })                
                this.error = rs.Error;
                
                if (rs.Error == "") {
                    for (let i = 0; i < rs.Data.length; i++) {
                        rs.Data[i].Created = this.convertEstTime(rs.Data[i].Created);
                    }
                    this.Messages = rs.Data;                 
                }
            },
            openFile(path) {
                window.open(path, "_blank");
            },
            
            async sendMessage() {                
                this.loading(true);
                const rs=await this.call({ Action: 'Support/SendMessage', Object: { TicketId: this.Ticket.Id, Message:$('#message').val() } })
                this.loading(false);
                
                this.error = rs.Error;                
                this.Messages = rs.Data;
                if (rs.Error != "") {
                    //show modal with callback name = loginView to check it whenever modal confirm triggerConfirm
                    this.showModal({ isShow: true, title: 'Error', content: rs.Error, type: 'error' });                  
                } else {                    
                    this.Messages = rs.Data;
                    $('#message').val('');
                }
            },

            async deleteMessage(Id) {
                this.loading(true);
                const rs = await this.call({ Action: 'Support/DeleteTicketMessage', Object: { MessageId: Id } })
                this.loading(false);

                this.error = rs.Error;

                if (rs.Error != "") {                    
                    this.showModal({ isShow: true, title: 'Error', content: rs.Error, type: 'error' });
                } else {
                    this.showModal({ isShow: true, title: 'Success', content: 'Message successfully deleted.', type: 'success' });
                    this.refreshMessage();
                }
            },

            async changeTicketStatus(status) {
                if (this.Ticket.Status != status) {                    
                    const rs = await this.call({ Action: 'Support/ChangeStatus', Object: { TicketId: this.Ticket.Id, Status: status } })                    
                    this.error = rs.Error;
                    if (rs.Error != "") {
                        //show modal with callback name = loginView to check it whenever modal confirm triggerConfirm
                        this.showModal({ isShow: true, title: 'Error', content: rs.Error, type: 'error' });
                    } else {                        
                        this.$store.dispatch('view/showToast', { title: '', content: 'Ticket saved!', type: 'success' });
                        this.Ticket.Status = status;
                        //Remove AutoClose Ticket
                        if (this.autoClose)
                            this.autoClose = false;

                        this.getTicketDetail(this.Ticket.Id);
                    }
                }
            },

            convertEstTime(date) {
                const estOffset = -5 * 60; // EST TimeZone

                const UtcTime = new Date(date);
                const EstTime = new Date(UtcTime.getTime() + estOffset * 60000);

                // Get day, month, year
                const day = EstTime.getDate();
                const month = EstTime.toLocaleString('default', { month: 'short' });
                const year = EstTime.getFullYear();

                // get hours, minute, second
                const hours = EstTime.getHours();
                const minutes = EstTime.getMinutes();
                const seconds = EstTime.getSeconds();

                // format time
                const formattedTime = `${this.padZero(hours)}:${this.padZero(minutes)}:${this.padZero(seconds)}`;

                // format full time
                const formattedEstTime = `${year}-${month}-${day}  ${formattedTime} (EST)`;

                return formattedEstTime;
            },

            padZero(value) {
                return value < 10 ? '0' + value : value; //add 0 for time
            },
            //===================== lightbox handle
            //https://vuejsexamples.com/a-vue-js-3-0-image-lightbox-component-with-zoom-and-drag/
            openLightbox(index) {
                //this.lightboxImgs = [
                //    'http://via.placeholder.com/350x150',
                //    'http://via.placeholder.com/350x150'
                //]
                // or
                const Files = this.parseScreenShot(this.Ticket.Files);
                console.log(Files);
                for (let i = 0; i < Files.length; i++) {
                    this.lightboxImgs.push({
                        title: Files[i],
                        src: this.Ticket.TicketPath + '/' + Files[i]
                    })
                }
                // allow mixing

                this.lightboxIndex = index // index of imgList
                this.lightboxShow()
            },
            lightboxShow() {
                this.lightboxVisible = true
            },
            lightboxHandleHide() {
                this.lightboxVisible = false
            },
            //==========================================
            showIndex() {                
                this.$router.push("/support");
            },
        },
        
        created() {
            
        },
        mounted() {            
            //if already login then start, 
            //else will watch isCheckedLogin to catch its change
            //to call start function
            if (this.isCheckedLogin) this.start();
        },
        unmounted() {
            clearInterval(this.myInterval);
        },
        watch: {
            //catch status from not login to logged in 
            //to call start function.
            //Apply for reload page issue
            isCheckedLogin(newVal) {
                if (newVal) {
                    this.start();
                }
            }
        }
    };
</script>
